'use client';
import { useEffect, useState } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { useDebounce } from '@/hooks';

/**
 * Custom hook for managing sports search query state and its synchronization with URL parameters.
 */
export const useSportCategorySearch = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const [searchQuery, setSearchQuery] = useState(searchParams.get('q') || '');
  const debouncedSearchQuery = useDebounce(searchQuery, 500);

  // Sync search query with URL params
  useEffect(() => {
    const params = new URLSearchParams(searchParams.toString());
    if (debouncedSearchQuery) {
      params.set('q', debouncedSearchQuery);
    } else {
      params.delete('q');
    }

    const queryString = params.toString();
    const targetUrl = queryString ? `${pathname}?${queryString}` : pathname;

    // Only update if the URL actually changes
    if (window.location.search !== `?${queryString}` && (window.location.search || queryString)) {
      router.replace(targetUrl, { scroll: false });
    }
  }, [debouncedSearchQuery, pathname, router, searchParams]);

  return {
    searchQuery,
    debouncedSearchQuery,
    setSearchQuery,
  };
};
